module.exports = __webpack_public_path__ + "static/media/master_product_01.114649ac.jpg";